import { Burger } from '@mantine/core';

import { AssetSelectorChip } from 'src/Components/NavBar/AssetSelectorChip';
import { CreateMenu } from 'src/Components/NavBar/CreateMenu';
import { Props } from 'src/Components/NavBar/NavBar.types';
import { NavBarLanguageMenu } from 'src/Components/NavBar/NavBarLanguageMenu';
import { TasksMenu } from 'src/Components/NavBar/TasksMenu';
import useIsMobile from 'src/Hooks/Shared/useIsMobile';

import styles from './NavBar.module.scss';
import { NavBarMenu } from './NavBarMenu';

const NavBar = ({ toggleMenu, menuOpen }: Props) => {
  const isMobile = useIsMobile();

  return (
    <div className={styles.container}>
      <div className={styles.leftSide}>
        <Burger opened={menuOpen} onClick={toggleMenu} hiddenFrom="sm" size="sm" />
        <AssetSelectorChip />
      </div>

      <div className={styles.rightSide}>
        {/* On mobile the header is cramped: tasks and language move into the avatar menu. */}
        {!isMobile && (
          <>
            <TasksMenu />
            <CreateMenu />
            <div className={styles.spacer} />
            <NavBarLanguageMenu />
            <div className={styles.spacer} />
          </>
        )}
        {isMobile && <CreateMenu />}
        <NavBarMenu />
      </div>
    </div>
  );
};

export default NavBar;
